module.exports = __webpack_public_path__ + "static/akitabox-75e545675955e65112feadfe38d9b6cd.png";